import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import ProfileTableNoDataResolver from "../ProfilesDetail/Table/NoDataView/resolver";
import ProfileLinkingModal from "./ProfileLinkingModal";
import {
  getDataQuery,
  tableColumnsResolver,
  profilesMachineNameResolver,
} from "./utils";
import GQLUtil from "../../global/utils/gqlHelper";
import { ReactTable } from "../SimpleForm/ReactTable";

const getTableData = (type, data) => {
  const accessors = {
    "foreign-worker-group": {
      req: "getForeignWorkerByGroupId",
      formData: "ForeignWorkerFormData",
    },
    "foreign-worker": {
      req: "getForeignWorkerGroupByGroupId",
      formData: "ForeignWorkerGroupFormData",
    },
    "foreign-worker-search": {
      req: "getForeignWorkerBySearch",
      formData: "ForeignWorkerFormData",
    },
  };
  const { req, formData } = accessors[type];

  return data[req].map((row) => ({ id: row.id, ...row[formData] }));
};

const getData = async (type, query, setProfiles, setLoading) => {
  setLoading(true);
  const data = await GQLUtil.genericGQLQuery(query);
  if (data.data) {
    setProfiles(getTableData(type, data.data));
  } else {
    setProfiles([]);
  }
  setLoading(false);
};

const getDataSearch = (search, type, user, setProfiles, setLoading) => {
  let query;
  if (search === null) {
    query = getDataQuery(type, user.Group.id, null);
  } else {
    query = getDataQuery(type, user.Group.id, search);
  }
  getData(type, query, setProfiles, setLoading);
};

const dataReset = (type, user, setProfiles, setLoading) => {
  const query = getDataQuery(type, user.Group.id, null);
  getData(type, query, setProfiles, setLoading);
};

const ProfileLinkingTable = ({
  type,
  formApi,
  linkingType,
  searchType,
  addButtonText,
  user,
}) => {
  const currentUser = useSelector((props) => props.appReducer.userDataReducer.data);
  const [modalOpen, setModalOpen] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [linkedProfiles, setLinkedProfiles] = useState([]);
  const columns = tableColumnsResolver(
    type,
    formApi,
    linkedProfiles,
    setLinkedProfiles
  );
  const noData = ProfileTableNoDataResolver(linkingType);
  const getQuery = getDataQuery(type, currentUser.Group.id);
  const machine_name = profilesMachineNameResolver(type);
  const currProfiles = profiles.filter((profile) =>
    formApi.getState().values[machine_name]?.includes(profile.id)
  );

  useEffect(() => {
    getData(type, getQuery, setProfiles, setLoading);
    setLinkedProfiles(formApi.getState().values[machine_name] ?? []);
  }, []);

  return (
    <>
      <div style={{ paddingBottom: "0.5rem" }}>
        <button
          type="button" // Removes default submit
          onClick={() => setModalOpen(true)}
          className="usa-button usa-button--outline"
        >
          <span>{addButtonText}</span>
        </button>
      </div>
      <ReactTable
        columns={columns}
        tableTheme="genericTheme"
        data={currProfiles}
        noDataComponent={noData}
        loading={loading}
        showPagination={!!currProfiles ? currProfiles.length > 5 : false}
        defaultSorted={[
          {
            id: columns[0].id,
            asc: true,
          },
        ]}
      />
      <ProfileLinkingModal
        open={modalOpen}
        setClose={() => setModalOpen(false)}
        loading={loading}
        profiles={profiles.filter((profile) => !currProfiles.includes(profile))}
        type={type}
        searchType={searchType}
        linkingType={linkingType}
        formApi={formApi}
        linkedProfiles={linkedProfiles}
        setLinkedProfiles={setLinkedProfiles}
        getDataSearch={getDataSearch}
        dataReset={dataReset}
        setSearch={setSearch}
        search={search}
        user={currentUser}
        setProfiles={setProfiles}
        setLoading={setLoading}
      />
    </>
  );
};

export default ProfileLinkingTable;
